import {News} from '../entities/news'
import {supabase} from './BackendService'
import {Language} from './language'
import urlProjectPhoto0 from 'url:../../public/assets/images/image1.jpg'

export const newsDefaultQuery =
  'id, news_title, news_title_ru, news_title_pl, news_text, news_text_ru, news_text_pl, title_photo, type, URL, created_at, tags:tagsVSNews( ...newsTags(id, tag_name, tag_name_ru, tag_name_pl, color) )'

export class NewsService {
  public DEFAULT_PER_PAGE = 10

  public async getNewsLists(newsCount: number = 10): Promise<News[]> {
    let {data: newsList, error} = await supabase
      .from('news')
      .select(newsDefaultQuery)
      .eq('draft', false)
      .order('created_at', {ascending: false})
      .limit(newsCount)

    return newsList?.map((news) => {
      const titlePhotoURL = supabase.storage.from('news').getPublicUrl(`/${news.title_photo}`)
      return {
        id: news.id,
        newsName: news.news_title,
        newsNameRU: news.news_title_ru,
        newsNamePL: news.news_title_pl,
        text: news.news_text?.slice(0, 200),
        textPL: news.news_text_pl?.slice(0, 200),
        textRU: news.news_text_ru?.slice(0, 200),
        dateOfCreating: news.created_at,
        titlePhotoURL: news.title_photo ? titlePhotoURL.data.publicUrl : urlProjectPhoto0,
        newsType: news.type,
        url: news.URL,
        tags: news.tags.map((t) => ({
          id: t.id,
          tagName: t.tag_name,
          tagNameRu: t.tag_name_ru,
          tagNamePl: t.tag_name_pl,
          color: t.color,
        })),
      }
    }) as News[]
  }
  public async getFilteredNewsLists(
    {
      page,
      perPage,
      searchQuery,
      tagFilters,
    }: {
      page: number
      perPage: number
      searchQuery: string
      tagFilters: string[]
    },
    language: Language
  ): Promise<{newsList: News[]; totalCount: number}> {
    let query = supabase
      .from('news')
      .select(
        'id, news_title, news_title_ru, news_title_pl, title_photo, news_text, news_text_ru, news_text_pl, type, URL, created_at',
        {count: 'exact'}
      )
      .eq('draft', false)
      .order('created_at', {ascending: false})
      .range((page - 1) * perPage, page * perPage - 1)

    if (tagFilters && tagFilters.length > 0) {
      query = query.filter('type', 'in', `(${tagFilters})`)
    }

    if (searchQuery) {
      query = query.filter(
        language === 'ru' ? 'news_title_ru' : 'news_title',
        'ilike',
        `%${searchQuery}%`
      )
    }

    let {data: newsList, count, error} = await query

    const filteredNewsList = newsList?.map((news) => {
      const titlePhotoURL = supabase.storage.from('news').getPublicUrl(`/${news.title_photo}`)

      return {
        id: news.id,
        newsName: news.news_title,
        newsNameRU: news.news_title_ru,
        newsNamePL: news.news_title_pl,
        dateOfCreating: news.created_at,
        titlePhotoURL: news.title_photo ? titlePhotoURL.data.publicUrl : urlProjectPhoto0,
        newsType: news.type,
        text: news.news_text?.slice(0, 200),
        textPL: news.news_text_pl?.slice(0, 200),
        textRU: news.news_text_ru?.slice(0, 200),
        url: news.URL,
      }
    }) as News[]

    return {newsList: filteredNewsList, totalCount: count}
  }
  public async getNewsById(newsURL: string): Promise<News> {
    let {data: newsById, error} = await supabase
      .from('news')
      .select(
        'id, news_title, news_title_ru, news_title_pl, title_photo, news_text, news_text_ru, news_text_pl, type, URL, created_at'
      )
      .eq('draft', false)
      .eq('URL', newsURL)

    const titlePhotoURL = supabase.storage.from('news').getPublicUrl(`/${newsById[0].title_photo}`)

    return {
      id: newsById[0].id,
      newsName: newsById[0].news_title,
      newsNameRU: newsById[0].news_title_ru,
      newsNamePL: newsById[0].news_title_pl,
      dateOfCreating: newsById[0].created_at,
      titlePhotoURL: newsById[0].title_photo ? titlePhotoURL.data.publicUrl : urlProjectPhoto0,
      newsType: newsById[0].type,
      text: newsById[0].news_text,
      textPL: newsById[0].news_text_pl,
      textRU: newsById[0].news_text_ru,
      url: newsById[0].URL,
    } as News
  }
}

export const instance = new NewsService()
